export default "__VITE_ASSET__DzofuRGo__"